const QUERIES = {
  ABOUTS_LIST: 'about',
  ANNOUNCEMENTS_LIST: 'announcements-list',
  ACADEMIC_YEARS_LIST: 'academic-year',
  SUMMARY_LIST: 'summary',
  ACCOUNTS_LIST: 'account',
  ASSET_CATEGORYS_LIST: 'asset-category',
  ASSET_ISSUES_LIST: 'asset-issue',
  ASSET_ITEMS_LIST: 'asset-item',
  ASSET_PURCHASES_LIST: 'asset-purchase',
  ASSET_STOCKS_LIST: 'asset-stock',
  ADMIT_CARD_SETTINGS_LIST: 'admit-card-settings-list',
  ACTIVITY_LOGS_LIST: 'activity-logs-list',
  ADMISSIONS_LIST: 'admission',
  ADMISSION_FIELD_LIST: 'admission-field',
  ASSET_STORES_LIST: 'store',
  ASSIGNMENT_SUBMISSIONS_LIST: 'assignment-submission',
  ASSIGNMENTS_LIST: 'assignment',
  AUTHORS_LIST: 'author',
  AWARDS_LIST: 'awards-list',
  BOOKS_LIST: 'book',
  BOOK_ISSUES_LIST: 'book-issue',
  CERTIFICATES_LIST: 'certificates-list',
  CLASSES_LIST: 'class',
  CLASS_GROUPS_LIST: 'class-groups-list',
  COMPLAIN_TYPES_LIST: 'complain-types-list',
  COMPLAINS_LIST: 'complains-list',
  DEPARTMENTS_LIST: 'department',
  DESIGNATIONS_LIST: 'designation',
  EMAIL_SETTINGS_LIST: 'email-settings-list',
  EMAILS_LIST: 'emails-list',
  DISCOUNTS_LIST: 'discounts-list',
  FEE_TYPES_LIST: 'fee-type',
  EMPLOYEE_ATTENDANCES_LIST: 'employee-attendance',
  ENROLLMENTS_LIST: 'enrollment',
  EMAIL_TEMPLATES_LIST: 'email-templates-list',
  EMPLOYEES_LIST: 'employee',
  EVENTS_LIST: 'events-list',
  EXAM_ANSWERS_LIST: 'exam-answers-list',
  EXAM_ATTENDANCES_LIST: 'exam-attendance',
  EXAM_INSTRUCTIONS_LIST: 'exam-instruction',
  EXAM_ONLINE_EXAMS_LIST: 'exam-online-exam',
  EXAM_QUESTIONS_LIST: 'exam-question',
  EXAM_QUESTION_ANSWERS_LIST: 'exam-question-answer',
  EXAM_RESULTS_LIST: 'exam-result',
  EXAM_SCHEDULES_LIST: 'exam-schedule',
  EXAM_TAKEN_EXAMS_LIST: 'exam-taken-exam',
  EXAMS_LIST: 'exam',
  EXAM_TERMS_LIST: 'exam-term',
  EXPENDITURE_HEADS_LIST: 'expenditure-head',
  FAQS_LIST: 'faqs-list',
  EXAM_TO_QUESTIONS_LIST: 'exam-to-question',
  FEES_AMOUNTS_LIST: 'fees-amounts-list',
  GALLERY_IMAGES_LIST: 'gallery-images-list',
  GALLERY_LIST: 'gallery',
  FINAL_RESULTS_LIST: 'final-results-list',
  GMSMS_SESSIONS_LIST: 'gmsms-sessions-list',
  GRADES_LIST: 'grade',
  HOLIDAYS_LIST: 'holidays-list',
  HOSTEL_MEMBERS_LIST: 'hostel-member',
  GLOBAL_SETTINGS_LIST: 'global-settings-list',
  INCIDENT_LIST: 'incident',
  INCIDENT_CATEGORY_LIST: 'incident-category',
  INCIDENT_COMMENTS_LIST: 'incident-comment',
  INCOME_LIST: 'income',
  INCOME_HEADS_LIST: 'income-heads-list',
  INVOICES_LIST: 'invoice',
  ID_CARD_SETTINGS_LIST: 'id-card-settings-list',
  ITEM_CATEGORYS_LIST: 'item-categorys-list',
  EXPENDITURES_LIST: 'expenditures-list',
  ITEM_PRODUCTS_LIST: 'item-products-list',
  INVOICE_DETAILS_LIST: 'invoice-details-list',
  ITEM_SALES_LIST: 'item-sales-list',
  ITEM_PURCHASES_LIST: 'item-purchases-list',
  ITEM_STOCKS_LIST: 'item-stocks-list',
  ITEM_SUPPLIERS_LIST: 'item-suppliers-list',
  FEEDBACKS_LIST: 'feedbacks-list',
  LANGUAGES_LIST: 'languages-list',
  LEAVE_APPLICATIONS_LIST: 'leave-application',
  LEAVE_TYPES_LIST: 'leave-type',
  LIVE_CLASSES_LIST: 'live-classs-list',
  LP_LESSON_DETAILS_LIST: 'lp-lesson-details-list',
  LP_LESSONS_LIST: 'lp-lessons-list',
  LP_TOPIC_DETAILS_LIST: 'lp-topic-details-list',
  LP_TOPICS_LIST: 'lp-topics-list',
  MARK_EMAILS_LIST: 'mark-emails-list',
  MARKS_LIST: 'mark',
  MARKSHEET_LIST: 'mark/marksheet',
  MARK_SMSES_LIST: 'mark-smses-list',
  MESSAGE_RELATIONSHIPS_LIST: 'message-relationships-list',
  MESSAGES_LIST: 'messages-list',
  MODULES_LIST: 'modules-list',
  NEWS_LIST: 'news',
  NOTICES_LIST: 'notice',
  OPENING_HOURS_LIST: 'opening-hours-list',
  OPERATIONS_LIST: 'operations-list',
  PAYMENT_SETTINGS_LIST: 'payment-setting',
  PAYMENTS_LIST: 'payment',
  ONLINE_PAYMENTS_LIST: 'online-payment',
  PAGES_LIST: 'pages-list',
  PHONE_CALL_LOGS_LIST: 'phone-call-logs-list',
  POSTAL_RECEIPTS_LIST: 'postal-receipts-list',
  PRIVILEGES_LIST: 'privileges-list',
  POSTAL_DISPATCHS_LIST: 'postal-dispatchs-list',
  PROFILE: 'profile',
  PROMOTIONS_LIST: 'exam-result/promotion',
  PURCHASES_LIST: 'purchases-list',
  PSYCHOMOTORS_LIST: 'psychomotor',
  EXAM_PSYCHOMOTORS_LIST: 'psychomotors-list',
  RATINGS_LIST: 'ratings-list',
  REPLYS_LIST: 'replys-list',
  RESULTS_LIST: 'results-list',
  RESULT_CARDS_LIST: 'exam-result/report',
  ROUTE_STOPS_LIST: 'route-stops-list',
  ROLES_LIST: 'role',
  ROOMS_LIST: 'room',
  ROUTES_LIST: 'routes-list',
  ROUTINES_LIST: 'routine',
  SAAS_FAQS_LIST: 'saas-faqs-list',
  SAAS_PLANS_LIST: 'saas-plans-list',
  SAAS_SETTINGS_LIST: 'saas-settings-list',
  SAAS_SLIDERS_LIST: 'saas-sliders-list',
  SAAS_SUBSCRIPTIONS_LIST: 'saas-subscriptions-list',
  SALARY_GRADES_LIST: 'salary-grades-list',
  ITEM_WAREHOUSES_LIST: 'item-warehouses-list',
  SECTIONS_LIST: 'section',
  SCHOOLS_LIST: 'school',
  SCHOOL_MARKS_LIST: 'school-mark',
  SCHOOL_PSYCHOMOTORS_LIST: 'school-psychomotor',
  SLIDERS_LIST: 'slider',
  HOSTELS_LIST: 'hostel',
  SMS_SETTINGS_LIST: 'sms-settings-list',
  SS_BALANCES_LIST: 'ss-balances-list',
  SS_CANDIDATES_LIST: 'ss-candidates-list',
  SS_DONORS_LIST: 'ss-donors-list',
  SS_SCHOLARSHIPS_LIST: 'ss-scholarships-list',
  STUDENT_ACTIVITYS_LIST: 'student-activitys-list',
  STUDENT_ATTENDANCES_LIST: 'student-attendance',
  STUDENT_TYPES_LIST: 'student-type',
  STUDENTS_LIST: 'student',
  STUDY_MATERIALS_LIST: 'study-materials-list',
  SUBJECTS_LIST: 'subject',
  SUGGESTIONS_LIST: 'suggestions-list',
  SYLLABUSS_LIST: 'syllabus',
  TEACHER_ATTENDANCES_LIST: 'teacher-attendances-list',
  TEACHERS_LIST: 'teachers-list',
  SYSTEM_ADMINS_LIST: 'system-admins-list',
  TEXT_MESSAGES_LIST: 'text-messages-list',
  THEMES_LIST: 'themes-list',
  TRANSACTIONS_LIST: 'transaction',
  TRANSPORT_MEMBERS_LIST: 'transport-members-list',
  TODOS_LIST: 'todos-list',
  USERS_LIST: 'user',
  VEHICLES_LIST: 'vehicles-list',
  VISITORS_LIST: 'visitors-list',
  VISITOR_PURPOSES_LIST: 'visitor-purposes-list',
  CLASS_LECTURES_LIST: 'class-lecture',
  SALARY_PAYMENTS_LIST: 'salary-payments-list',
  SMS_TEMPLATES_LIST: 'sms-templates-list',
  ITEM_ISSUES_LIST: 'item-issues-list',
}

export {QUERIES}
